import React, {Component} from 'react';
import './ItemMintMonetizationDetails.css';
import { mainnetContractAddress, mainnetBondingCurveContractAddress } from "./config";
import * as loggingUtils from './utils/loggingUtils';
import * as encryptUtils from "./encryptDecryptUtils";
import { HiExternalLink } from "react-icons/hi";

const axios = require('axios');

class ItemMintMonetizationDetails extends Component {
  constructor(props) {
    super(props);
    this.getUSD = this.getUSD.bind(this);

    this.state = {
      maticToWeiConversion: 1000000000000000000,
      USDPrice: "Invalid coinbase exchange rate request",
    }
  }

  async getUSD(){
    let USDPrice = "Invalid coinbase exchange rate request"
    let data = await axios.get("https://api.coinbase.com/v2/exchange-rates", { params: { currency: "MATIC" } });
    if(data != null) {
      USDPrice = data["data"]["data"]["rates"]["USD"]
    }
    return USDPrice;
  }

  async componentDidMount() {
    let data = await axios.get("https://api.coinbase.com/v2/exchange-rates", { params: { currency: "MATIC" } });
    if(data != null) {
      this.setState({
        USDPrice: data["data"]["data"]["rates"]["USD"]
      })
    }
  }

  render() {
    let holderRoyaltyShares = parseInt(this.props.item.royaltySharesInfo.holderShares);
    let creatorRoyaltyShares = parseInt(this.props.item.royaltySharesInfo.creatorShares);
    let editions = parseInt(this.props.item.mintLimit);
    let totalShares = holderRoyaltyShares * editions + creatorRoyaltyShares;
    let holderRoyaltyPercentage = parseInt(holderRoyaltyShares * 100 / totalShares);
    let contractAddress;
    if(this.props.item.protocol === "the402") {
      contractAddress = mainnetContractAddress
    } else if(this.props.item.protocol === "liquid") {
      contractAddress = mainnetBondingCurveContractAddress;
    } else {
      contractAddress = this.props.item.tokenContractAddress;
    }
    return (
      <div className="mt-8 pb-4 md:pb-32">
        <div className = "text-black dark:text-white font-semibold">
          NFT Details
        </div>
        <div className = "flex flex-col dark:bg-custom-gray bg-gray-100 rounded-md w-80 sm:w-112 h-80 mt-4 mb-4 border-2 dark:border-0 dark:shadow-[0px_0px_2px_#787878] justify-around">
          {
            this.props.protocol !== "liquidv2"
              ?
            <div className = "flex flex-col w-80 ml-8">
              <div className = "text-gray-500 dark:text-gray-300 text-xs">
                ROYALTY
              </div>
              <div className = "flex dark:text-white text-black items-center text-base">
                {this.props.item.royalty + "%"}
              </div>
            </div>
              :
            null
          }
          {
            this.props.protocol === "the402"
              ?
            <div className = "flex flex-col w-80 ml-8">
              <div className = "text-gray-500 dark:text-gray-300 text-xs">
                IMPRESSION FEE
              </div>
              <div className = "flex dark:text-white text-black items-center text-base">
                {((this.props.item.impressionFee / this.state.maticToWeiConversion)).toFixed(2)+ " MATIC"}
              </div>
              <div>
                {"$ "+(this.props.item.impressionFee*this.getUSD())}
              </div>
            </div>
              :
            <div className = "flex flex-col w-80 ml-8">
              <div className = "text-gray-500 dark:text-gray-300 text-xs">
                CREATOR % FEE ON BUYS
              </div>
              <div className = "flex dark:text-white text-black items-center text-base">
                {this.props.item.currentBuyFeePerThousand/10 + "%"}
              </div>
            </div>
          }
          {
            this.props.protocol === "the402"
              ?
            <div className = "flex flex-col w-80 ml-8">
              <div className = "text-gray-500 dark:text-gray-300 text-xs">
                IMPRESSION % SHARE
              </div>
              <div className = "flex dark:text-white text-black items-center text-base">
                {holderRoyaltyPercentage + "%"}
              </div>
            </div>
              :
            !this.props.item.isNonLiquid
              ?
            <div className = "flex flex-col w-80 ml-8">
              <div className = "text-gray-500 dark:text-gray-300 text-xs">
                CREATOR % FEE ON SELLS
              </div>
              <div className = "flex dark:text-white text-black items-center text-base">
                {this.props.item.currentSellFeePerThousand/10 + "%"}
              </div>
            </div>
              :
            null
          }
          <div className = "flex flex-col w-80 ml-8">
            <div className = "text-gray-500 dark:text-gray-300 text-xs">
              CONTRACT ADDRESS
            </div>
            <div
              className = "flex dark:text-white text-black items-center text-base cursor-pointer w-auto"
              onClick={() => {
                loggingUtils.logEvent(
                  this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
                  'item_dedicated_page',
                  'item_dedicated_page_visit_contract_link',
                  'info',
                  "https://the402.xyz",
                  {},
                );
                if(process.env.REACT_APP_IS_MAINNET !== "testnet") {
                  window.open("https://etherscan.io/address/" + contractAddress, '_blank');
                } else {
                  window.open("https://goerli.etherscan.io/address/" + contractAddress, '_blank');
                }
              }}
            >
              <div className="mr-2">
                { "0x....." + contractAddress.substring(contractAddress.length - 6) }
              </div>
              <HiExternalLink />
            </div>
          </div>
          <div className = "flex flex-col w-80 ml-8">
            <div className = "text-gray-500 dark:text-gray-300 text-xs">
              IPFS
            </div>
            <div
              className = "flex dark:text-white text-black items-center text-base cursor-pointer w-auto"
              onClick={() => {
                loggingUtils.logEvent(
                  this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
                  'item_dedicated_page',
                  'item_dedicated_page_visit_item_metadata_link',
                  'info',
                  "https://the402.xyz",
                  {
                    item: this.props.item
                  },
                );
                window.open(this.props.item.uri, '_blank');
              }}
            >
              <HiExternalLink />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ItemMintMonetizationDetails;
